import { useMutation } from 'react-query';

import { useSecurePortalFetcher } from '../hooks';
import {
  ApiError,
  DownloadDocumentRequest,
  DownloadDocumentResponse,
  DownloadFilesRequest,
  DownloadFilesResponse,
  DownloadStatusRequest,
  DownloadStatusResponse,
} from '../models';

export const useDownloadDocumentMutation = () => {
  const fetcher = useSecurePortalFetcher();

  return useMutation<
    DownloadDocumentResponse,
    ApiError,
    DownloadDocumentRequest
  >(async ({ documentId }: { documentId: string }) => {
    const { data } = await fetcher<DownloadDocumentResponse>(
      `/v1/documents/${documentId}`
    ).json();

    return data;
  });
};

export const useDownloadFilesMutation = () => {
  const fetcher = useSecurePortalFetcher();

  return useMutation<DownloadFilesResponse, ApiError, DownloadFilesRequest>(
    async ({ documentIds, folderIds }) => {
      const { data } = await fetcher<DownloadFilesResponse>(`/v1/download`, {
        method: 'POST',
        json: { documentIds, folderIds },
      }).json();

      return data;
    }
  );
};

export const useDownloadStatusMutation = () => {
  const fetcher = useSecurePortalFetcher();

  return useMutation<DownloadStatusResponse, ApiError, DownloadStatusRequest>(
    async ({ processId }) => {
      const { data } = await fetcher<DownloadStatusResponse>(
        `/v1/download/${processId}/status`
      ).json();

      return data;
    }
  );
};
